module.exports = __webpack_public_path__ + "img/room.30efcb83.svg";